import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { mockTeamMembers, mockIndustries } from '../mock';

const About = () => {
  return (
    <div className="dark-page">
      <section className="page-hero">
        <div className="hero-image-wrapper">
          <img 
            src="https://images.unsplash.com/photo-1497366811353-6870744d04b2" 
            alt="Modern boardroom with natural light"
            className="hero-background-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <h1 className="display-large">About genTechStaffing</h1>
        <p className="body-large page-subtitle">
          The IT and AI Partner That Delivers Results
        </p>
      </section>

      <section className="about-content-section">
        <div className="about-story-with-image">
          <div className="about-story">
            <h2 className="display-medium">Who We Are</h2>
            <p className="body-large">
              genTechStaffing combines deep IT staffing expertise with cutting-edge AI and automation capabilities. Since 2010, we've helped organizations across North America close technology gaps, accelerate digital transformation, and build high-performing teams.
            </p>
            <p className="body-large">
              With offices across Canada—including Toronto, Vancouver, Calgary, Montreal, Ottawa, Edmonton, Kitchener-Waterloo, Québec, and Saskatoon—we deliver local expertise with national reach. Whether you need AI strategy, generative AI implementation, RPA automation, enterprise system integration, or qualified IT professionals—we deliver outcomes, not just resources.
            </p>
          </div>
          <div className="about-image">
            <img 
              src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2" 
              alt="Professional business environment"
              className="section-image"
            />
          </div>
        </div>

        <div className="about-values">
          <h2 className="display-medium">What Drives Us</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3 className="heading-2">Results Over Resources</h3>
              <p className="body-medium">We measure success by outcomes delivered, not hours billed</p>
            </div>
            <div className="value-card">
              <h3 className="heading-2">Speed with Precision</h3>
              <p className="body-medium">Fast delivery without compromising quality or cultural fit</p>
            </div>
            <div className="value-card">
              <h3 className="heading-2">Transparency</h3>
              <p className="body-medium">Clear processes, honest communication, and full visibility</p>
            </div>
            <div className="value-card">
              <h3 className="heading-2">Partnership</h3>
              <p className="body-medium">We succeed when you succeed—your goals become our goals</p>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section">
        <h2 className="display-medium">Leadership Team</h2>
        <div className="team-grid">
          {mockTeamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <div className="team-avatar">{member.name.charAt(0)}</div>
              <h3 className="heading-3">{member.name}</h3>
              <p className="body-small team-role">{member.role}</p>
              <p className="body-medium">{member.bio}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="industries-section">
        <h2 className="display-medium">Industries We Serve</h2>
        <div className="industries-grid">
          {mockIndustries.map((industry, idx) => (
            <div key={idx} className="industry-tag">
              {industry}
            </div>
          ))}
        </div>
      </section>

      <section className="cta-section">
        <h2 className="display-medium">Ready to Move Forward?</h2>
        <p className="body-large cta-subtitle">
          Let's discuss how we can help you close technology gaps and accelerate your digital initiatives.
        </p>
        <Link to="/contact" className="btn-primary btn-large">
          Start the Conversation
          <ArrowRight size={24} />
        </Link>
      </section>
    </div>
  );
};

export default About;